<div
  class="grid-view-card file-card"
  [ngClass]="cardClass"
  [ngStyle]="$any(cardStyle)"
  [class.preview-clickable]="previewable"
  [class.expanded]="expanded"
  [class.selected]="selected"
  (click)="onCardClick($event)">
  <div
    *ngIf="selectable || showCheckbox"
    class="checkbox-wrapper"
    [class.checked]="selected"
    (click)="onCheckboxClick($event)">
    <div class="custom-checkbox">
      <i *ngIf="selected" class="pi pi-check"></i>
    </div>
  </div>
  <div class="grid-view-card-preview-wrapper">
    <ng-content select="[grid-card-badge]"></ng-content>
    <div class="grid-view-card-preview-frame">
      <img
        *ngIf="imageSrc"
        [src]="imageSrc"
        [alt]="title"
        class="grid-view-card-preview"
        (error)="previewError.emit($event)" />
      <video
        *ngIf="!imageSrc && videoSrc"
        [src]="videoSrc"
        class="grid-view-card-preview"
        muted
        playsinline
        (error)="previewError.emit($event)"></video>
      <pdf-viewer
        *ngIf="!imageSrc && !videoSrc && pdfSrc"
        [src]="pdfSrc"
        [render-text]="false"
        [show-all]="false"
        [page]="1"
        [original-size]="false"
        [fit-to-page]="true"
        [autoresize]="true"
        [show-borders]="false"
        class="grid-view-card-preview grid-view-card-pdf-preview"
        (error)="previewError.emit($event)"></pdf-viewer>
      <img
        *ngIf="!imageSrc && !videoSrc && !pdfSrc && fallbackIconSrc"
        [src]="fallbackIconSrc"
        [alt]="fallbackAlt || title"
        class="grid-view-card-preview grid-view-card-preview-icon" />
    </div>
  </div>

  <div class="grid-view-card-footer" [ngClass]="footerClass" (click)="$event.stopPropagation()">
    <div class="grid-view-card-footer-main">
      <h3
        class="grid-view-card-title"
        [ngbTooltip]="title"
        [disableTooltip]="!title"
        placement="top"
        container="body">
        {{ title }}
      </h3>
      <div (click)="$event.stopPropagation()">
        <ng-content select="[grid-card-actions]"></ng-content>
      </div>
    </div>

    <ng-content select="[grid-card-footer]"></ng-content>
  </div>
</div>
